import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm, Col, Tabs,
} from 'antd';

import { asyncGet, actions,resend,asyncGetQ ,} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Edit from './edit.js';
import { delect } from './reducers';
import Urls from "../../../../config";
const TabPane = Tabs.TabPane;
class Certificate extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
      //  this.props.asyncGetQ();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();

    };
    changeHandle1 = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGetQ();

    };

    reStart = record => {
        const { scriptId } = record;
        this.props.reStart({ scriptIds: [scriptId], action: '7', executeNow: true });
        this.props.asyncGet();
    }

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.certificateId);
    }

    resend = record => {
       this.props.resend(record);
       this.props.asyncGetQ();
    }
    handleDelete = async record => {
        record.deleteFlag = '1';
        this.props.delect(record);
        this.props.asyncGet();
    }

    renderAction = (text, record) => {
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.edit(record); }} >
                    编辑
                </Button>

                <Popconfirm title="是否删除?" onConfirm={() => { this.handleDelete(record); }} >
                    <Button type="primary" style={{ marginRight: '5px' }} size="small">
                        < a href="#">删除</a>
                    </Button>
                </Popconfirm>
            </div>
        );
    };
    renderAction1 = (text, record) => {
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => { this.resend(record); }} >
                    重新发送
                </Button>
            </div>
        );
    };

    tabsChange =(key) =>{
        this.props.setKeys(key);
        if(key=='1'){
            this.props.asyncGet();
        }else{
            this.props.asyncGetQ();
        }
    }
    onSelectChange = (selectedRowKeys, selectedRows) => { //selectedRowKeys  指定选中项的 key 数组
        this.props.getTransferData({ selectedRowKeys });
        this.props.getSele(selectedRowKeys);
    }

    render() {
        let { list, uiStatus, pagination, transferData ,listQ} = this.props;
        const { selectedRowKeys } = transferData;
        let { isLoading } = uiStatus;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const columns = [
            {
                title: '证书ID',
                dataIndex: 'certificateId',
                key: 'certificateId',
            },
            {
                title: '密码',
                dataIndex: 'pwd',
                key: 'pwd',
            },
            {
                title: '创建时间',
                dataIndex: 'ceateTime',
                key: 'ceateTime',
            },
            {
                title: 'uuid',
                dataIndex: 'udid',
                key: 'udid',
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction(text, record, index);
                },
            },
        ];

        const columnsQ = [
            {
                title: '客户端id',
                dataIndex: 'clientId',
                key: 'clientId',
            },
            {
                title: '证书id',
                dataIndex: 'certificateId',
                key: 'certificateId',
            },
            {
                title: 'token',
                dataIndex: 'token',
                key: 'token',
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
            },
            {
                title: '返回结果',
                dataIndex: 'result',
                key: 'result',
            },
            {
                title: '操作',
                dataIndex: 'action',
                key: 'action',
                render: (text, record, index) => {
                    return this.renderAction1(text, record, index);
                },
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Tabs defaultActiveKey="1" onChange={this.tabsChange}>
                        <TabPane tab="证书管理" key="1">
                            <Table
                                columns={columns}
                                dataSource={list}
                                pagination={{
                                    ...pagination,
                                }}
                                defaultExpandAllRows={false}
                                onChange={this.changeHandle}
                            />
                        </TabPane>
                        <TabPane tab="请求管理" key="2">
                            <Table
                                columns={columnsQ}
                                dataSource={listQ}
                                pagination={{
                                    ...pagination,
                                }}
                                defaultExpandAllRows={false}
                                onChange={this.changeHandle1}
                            />
                        </TabPane>
                    </Tabs>
                    <Edit />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    selectedContent: state.certificateList.selectedContent,
    list: state.certificateList.list,
    listQ: state.certificateList.listQ,
    pagination: state.certificateList.pagination,
    proxyrepeatinfo: state.certificateList.proxyrepeatinfo,
    uiStatus: state.certificateList.uiStatus,
    agentsGroup: state.certificateList.agentsGroup,
    transferData: state.certificateList.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    asyncGetQ: () => dispatch(asyncGetQ()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delUser: id => dispatch(actions.del(id)),
    delect: record => dispatch(delect(record)),
    delectAll: selectedRowsCurr1 => dispatch(delectAll(selectedRowsCurr1)),
    getTransferData: data => dispatch(actions.getTransferData(data)),
    changePagination: data => dispatch(actions.changePagination(data)),
    getUserGroups: () => dispatch(getUserGroups()),
    getSele: data => dispatch(actions.getSele(data)),
    resend: data => dispatch(resend(data)),
    setKeys: data => dispatch(actions.setKeys(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Certificate);



// WEBPACK FOOTER //
// ./pages/client/certificateList/index.js